import { createReducer, on } from '@ngrx/store';
import { PHASE_ONE, PHASE_TWO } from '../../../model/phases.model';
import * as phaseTwoAction from './phase-two-actions';

export const phaseTwoInitialState: PHASE_TWO = {
  FourData: undefined,
  DoneBySkip: false,
};

export const phaseTwoReducer = createReducer(
  phaseTwoInitialState,
  on(phaseTwoAction.ADD_PHASE_TWO, (state: PHASE_ONE, { payload }) => {
    return { ...payload };
  })
);
